import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import Container, { ErrorMessage } from './styles';

const FormikInput = ({
  name,
  placeholder,
  error,
  touched,
  type,
  isSmall,
  className,
  labelContent,
  ...other
}) => (
  <Container hasLabel={!!labelContent} isSmall={isSmall} className={className}>
    <Field
      name={name}
      type={type}
      placeholder={placeholder}
      {...other}
    />
    {labelContent && <label htmlFor={name}>{labelContent}</label>}
    <ErrorMessage name={name} component="div" />
  </Container>
);

FormikInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  type: PropTypes.string,
  isSmall: PropTypes.bool,
  className: PropTypes.string,
  labelContent: PropTypes.node,
};

FormikInput.defaultProps = {
  placeholder: '',
  error: '',
  touched: false,
  type: 'text',
  isSmall: false,
  className: 'formikInput',
  labelContent: null,
};

export default FormikInput;
